export const PASSWORD_OR_EMAIL_INCORRECT_PROMPT =
  "Your email or password is incorrect. Please try again";

export const GENERAL_ERROR_PROMPT =
  "Oops, an unexpected error has occurred. Please try again.";

export const EMPTY_INPUT_HELPER_MSG = "This field cannot be empty";

export const YEAR_ENROLLED_BEFORE_PEER_YEAR = "This cannot be after your peer year"